export const SAVE_APPLY_LOAN_PROGRESS = 'SAVE_APPLY_LOAN_PROGRESS' // 保存贷款流程进度

export const GET_STEP1_INITIAL_STATE = 'GET_STEP1_INITIAL_STATE'
export const GET_STEP1_INITIAL_DATA = 'GET_STEP1_INITIAL_DATA'
export const SET_STEP1_INITIAL_DATA = 'SET_STEP1_INITIAL_DATA'
export const SAVE_STEP1_DATA = 'SAVE_STEP1_DATA'

export const GET_SAVED_STEP1_DATA = 'GET_SAVED_STEP1_DATA'

export const GET_CONFIRM_LOAN_DATA_STATE = 'GET_CONFIRM_LOAN_DATA_STATE'
export const GET_CONFIRM_LOAN_DATA = 'GET_CONFIRM_LOAN_DATA'
export const SET_CONFIRM_LOAN_DATA = 'SET_CONFIRM_LOAN_DATA'
export const SET_STEP1_INITIAL_DATA_REPAY_TYPE = 'SET_STEP1_INITIAL_DATA_REPAY_TYPE'



// WEBPACK FOOTER //
// ./src/vuex/types/applyLoan/step1.js